import { Component } from '@angular/core';

@Component({
    selector: 's-home-root',
    styleUrls: ['./app.component.css'],
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  public title = 'home';
}
